const popout = () => {

	const $triggers = document.querySelectorAll('.popout');
	$triggers.forEach($el => {
		const $close = $el.querySelector('.close');

		$close.addEventListener('click', ev => {
			ev.preventDefault();

			close($el)
		})
	});
};

const close = ($el) => {
	$el.classList.remove('is-active');
}

const open = ($el) => {
	$el.classList.add('is-active');
}

module.exports = {
	init: popout,
	close: close,
	open: open
};
